import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ReactComponent as CaretLeftIcon } from '../../../../assets/images/caret-left.svg';
import { isDedicated } from '../../../../../shared/styles';

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e8e9eb;
`;

const StyledBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  width: 2rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const StyledCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  width: 2rem;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

function CloseIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="#232323"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

type Props = {
  onBack?: () => void;
  onClose?: () => void;
};

export function AuthHeader({ onBack, onClose }: Readonly<Props>) {
  const allowClose = useMemo(
    () =>
      !isDedicated(globalThis.xprops.renderAs) && typeof onClose === 'function',
    [onClose]
  );

  return (
    <StyledHeader>
      {onBack ? (
        <StyledBackButton onClick={onBack} aria-label="Go back">
          <CaretLeftIcon />
        </StyledBackButton>
      ) : (
        <span style={{ width: '2rem' }} />
      )}
      <span />
      {allowClose ? (
        <StyledCloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </StyledCloseButton>
      ) : (
        <span style={{ width: '2rem' }} />
      )}
    </StyledHeader>
  );
}
